// extracted by mini-css-extract-plugin
export default {"Award3":"Awards_Award3__qRhTS","Award4":"Awards_Award4__PrCHO","Award9":"Awards_Award9__PxA8x"};